export const manualChange =
  (fetch: Client.HttpClient) =>
  (processDefinitionId: number, data: Sentinel.Processes.ManualChangeRequest) =>
    fetch.put<Sentinel.Processes.ManualChangeRequest, void>(
      `/api/processExecution/${processDefinitionId}/manualChange`,
      { body: data }
    );
